import { useEffect, useRef } from "react";
import { Routes as RouterRoutes, Route, useLocation } from "react-router-dom";
import AdvancedSearch from "./Components/AdvancedSearch/AdvancedSearch";
import AdvancedSearchResults from "./Components/AdvancedSearchResults/AdvancedSearchResults";
import Login from "./Components/Login/Login";
import Messaging from "./Components/Conversations/Conversations";
import UserProfile from "./Components/UserProfile/UserProfile";
import PrivateRoute from "./Components/Utilities/PrivateRoute";
import AccountActivation from "./Components/AccountActivation/AccountActivation";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import NoMatch from "./Components/NoMatch";
import ForgotPassword from "./Components/ForgotPassword/ForgotPassword";
import ResetPassword from "./Components/ResetPassword/ResetPassword";
import usePusher from "./hooks/usePusher";

const Routes = () => {
  const location = useLocation();
  const transitionNodeRef = useRef(null);

  const { setupPusher, user } = usePusher();

  useEffect(() => {
    if (user) {
      setupPusher();
    }
  }, [user, setupPusher]);

  return (
    <TransitionGroup>
      <CSSTransition
        key={location.pathname}
        nodeRef={transitionNodeRef}
        classNames="fade"
        exit={false}
        timeout={500}
      >
        <div ref={transitionNodeRef} className="h-screen">
          <RouterRoutes location={location}>
            <Route path="/login" element={<Login />} />
            <Route path="/activation" element={<AccountActivation />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route
              path="/"
              element={<PrivateRoute><AdvancedSearch /></PrivateRoute>}
            />
            <Route
              path="/search"
              element={<PrivateRoute><AdvancedSearch /></PrivateRoute>}
            />
            <Route
              path="/results"
              element={<PrivateRoute><AdvancedSearchResults /></PrivateRoute>}
            />
            <Route
              path="/profile/:id"
              element={<PrivateRoute><UserProfile /></PrivateRoute>}
            />
            <Route
              path="/conversations"
              element={<PrivateRoute><Messaging /></PrivateRoute>}
            />
            <Route
              path="/conversations/:chat_id"
              element={<PrivateRoute><Messaging /></PrivateRoute>}
            />
            <Route
              path="*"
              element={<PrivateRoute><NoMatch /></PrivateRoute>}
            />
          </RouterRoutes>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default Routes;
